import React from "react"
import Layout from "../components/layout"
import SEO from "../components/seo"
import { LazyLoadImage } from "react-lazy-load-image-component"
import "react-lazy-load-image-component/src/effects/blur.css"

import CanineOrtho from "../images/canine-ortho-logo.jpg"
import SouthernColorado from "../images/southern-colorado.png"
import AnimalDentalCare from "../images/animal-dental-care.jpg"
import AnimalERCare from "../images/animal-er-care-2.png"
import MountainView from "../images/mountain-view.png"
import AADC from "../images/AADC-logo.jpeg"

class IndexPage extends React.Component {
  render() {
    const siteTitle = this.props.data.site.siteMetadata.title
    const siteDescription = this.props.data.site.siteMetadata.description
    return (
      <Layout location={this.props.location} title={siteTitle} id="back-to-top">
        <SEO title={siteTitle} description={siteDescription} />
        <div className="hero">
          <div
            className="container"
            style={{
              backgroundPosition: "center",
              backgroundSize: "cover",
            }}
          >
            <div className="row">
              <div className="col-12 col-md-12 col-lg-5" />
              <div className="col-12 col-md-12 col-lg-7">
                <div className="text-center">
                  <h2
                    data-aos="fade-down"
                    data-aos-duration="600"
                    data-aos-delay="1000"
                    className="vet-h1"
                  >
                    VETERINARY SPECIALTY <br /> CENTER
                  </h2>
                  <h4
                    data-aos="fade"
                    data-aos-duration="600"
                    data-aos-delay="600"
                    className="vet-h4"
                  >
                    Because Pets Enrich Our Lives.
                  </h4>
                </div>
              </div>
            </div>
          </div>
        </div>
        \
        <div className="our-work pt-5">
          <div className="container">
            <div className="row">
              <div className="col-12 text-center">
                <h4 data-aos="fade-down" data-aos-duration="600">
                  The Veterinary Specialty Center is located at: <br /> 5520 N.
                  Nevada Ave. <br /> Colorado Springs, CO 80918
                </h4>
                <h4>
                  While all practices are located on the Veterinary Specialty
                  Center campus, each operates independently.
                </h4>
                <h4>Please find their contact information below.</h4>
                <hr data-aos="fade" className="mx-auto my-5" />
              </div>
              <div className="col-12">
                <div className="row align-items-center">
                  <div className="col-12 col-md-6 details-img  text-center">
                    <LazyLoadImage
                      src={CanineOrtho}
                      alt="Colorado Canine Ortho Orthopedics & Rehab"
                      className="img-fluid"
                      effect="blur"
                    />
                  </div>
                  <div className="col-12 col-md-6 details-info">
                    <p>
                      <strong>COLORADO CANINE ORTHOPEDICS & REHAB</strong>
                    </p>
                    <div className="contact">
                      <div className="contact-item">
                        <div className="contact-icon">
                          <span className="fa fa-phone" />
                        </div>
                        <div className="contact-label">PHONE NUMBER</div>
                        <div className="contact-text">
                          <a href="tel:7192646666">719-264-6666</a>
                        </div>
                      </div>
                      <div className="contact-item">
                        <div className="contact-icon">
                          <span className="fa fa-globe" />
                        </div>
                        <div className="contact-label">WEBSITE</div>
                        <div className="contact-text">
                          <a
                            href="https://www.canineortho.com/"
                            target="_blank"
                            rel="noopener noferrer"
                          >
                            www.canineortho.com
                          </a>
                        </div>
                      </div>
                      <div className="contact-item">
                        <div className="contact-icon">
                          <span className="fa fa-paw" />
                        </div>
                        <div className="contact-label">SPECIALTY</div>
                        <div className="contact-text">
                          Canine Orthopedic Surgery & Rehabilitation
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <hr data-aos="fade" className="mx-auto my-5" />
                <div className="row align-items-center">
                  <div className="col-12 col-md-6 details-img  text-center">
                    <LazyLoadImage
                      src={SouthernColorado}
                      alt="Southern Colorado Veterinary Internal Medicine"
                      className="img-fluid"
                      effect="blur"
                    />
                  </div>
                  <div className="col-12 col-md-6 details-info">
                    <div className="contact">
                      <p>
                        <strong>
                          SOUTHERN COLORADO VETERINARY INTERNAL MEDICINE
                        </strong>
                      </p>
                      <div className="contact-item">
                        <div className="contact-icon">
                          <span className="fa fa-phone" />
                        </div>
                        <div className="contact-label">PHONE NUMBER</div>
                        <div className="contact-text">
                          <a href="tel:7192724004">719-272-4004</a>
                        </div>
                      </div>
                      <div className="contact-item">
                        <div className="contact-icon">
                          <span className="fa fa-globe" />
                        </div>
                        <div className="contact-label">WEBSITE</div>
                        <div className="contact-text">
                          <a
                            href="https://www.imvets.com/"
                            target="_blank"
                            rel="noopener noferrer"
                          >
                            www.imvets.com
                          </a>
                        </div>
                      </div>
                      <div className="contact-item">
                        <div className="contact-icon">
                          <span className="fa fa-paw" />
                        </div>
                        <div className="contact-label">SPECIALTY</div>
                        <div className="contact-text">
                          Veterinary Internal Medicine
                        </div>
                      </div>
                      <div className="contact-item">
                        <div className="contact-icon">
                          <span className="fa fa-medkit" />
                        </div>
                        <div className="contact-label">VET REFERRAL PORTAL</div>
                        <div className="contact-text">
                          <a
                            href="http://www.veterinaryspecialty.com/vets"
                            target="_blank"
                            rel="noopener noferrer"
                          >
                            Log In Here
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <hr data-aos="fade" className="mx-auto my-5" />
                <div className="row align-items-center">
                  <div className="col-12 col-md-6 details-img  text-center">
                    <LazyLoadImage
                      src={AnimalDentalCare}
                      alt="Animal Dental Care"
                      className="img-fluid"
                      effect="blur"
                    />
                  </div>
                  <div className="col-12 col-md-6 details-info">
                    <div className="contact">
                      <p>
                        <strong>ANIMAL DENTAL CARE</strong>
                      </p>
                      <div className="contact-item">
                        <div className="contact-icon">
                          <span className="fa fa-phone" />
                        </div>
                        <div className="contact-label">PHONE NUMBER</div>
                        <div className="contact-text">
                          <a href="tel:7195369949">719-536-9949</a>
                        </div>
                      </div>
                      <div className="contact-item">
                        <div className="contact-icon">
                          <span className="fa fa-globe" />
                        </div>
                        <div className="contact-label">WEBSITE</div>
                        <div className="contact-text">
                          <a
                            href="https://www.wellpets.com/"
                            target="_blank"
                            rel="noopener noferrer"
                          >
                            www.wellpets.com
                          </a>
                        </div>
                      </div>
                      <div className="contact-item">
                        <div className="contact-icon">
                          <span className="fa fa-paw" />
                        </div>
                        <div className="contact-label">SPECIALTY</div>
                        <div className="contact-text">
                          Veterinary Dentistry & Oral Surgery
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <hr data-aos="fade" className="mx-auto my-5" />
                <div className="row align-items-center">
                  <div className="col-12 col-md-6 details-img text-center">
                    <LazyLoadImage
                      src={AnimalERCare}
                      alt="Animal ER Care"
                      className="img-fluid"
                      effect="blur"
                      style={{ maxWidth: "20em" }}
                    />
                  </div>
                  <div className="col-12 col-md-6 details-info">
                    <div className="contact">
                      <p>
                        <strong>ANIMAL ER CARE</strong>
                      </p>
                      <div className="contact-item">
                        <div className="contact-icon">
                          <span className="fa fa-phone" />
                        </div>
                        <div className="contact-label">PHONE NUMBER</div>
                        <div className="contact-text">
                          <a href="tel:7192607141">719-260-7141</a>
                        </div>
                      </div>
                      <div className="contact-item">
                        <div className="contact-icon">
                          <span className="fa fa-globe" />
                        </div>
                        <div className="contact-label">WEBSITE</div>
                        <div className="contact-text">
                          <a
                            href="https://www.animalercare.com/"
                            target="_blank"
                            rel="noopener noferrer"
                          >
                            www.animalercare.com
                          </a>
                        </div>
                      </div>
                      <div className="contact-item">
                        <div className="contact-icon">
                          <span className="fa fa-paw" />
                        </div>
                        <div className="contact-label">SPECIALTY</div>
                        <div className="contact-text">
                          Emergency Veterinary Care
                        </div>
                      </div>
                      <div className="contact-item">
                        <div className="contact-icon">
                          <span className="fa fa-medkit" />
                        </div>
                        <div className="contact-label">VET REFERRAL PORTAL</div>
                        <div className="contact-text">
                          <a href="http://www.veterinaryspecialty.com/vets">
                            Log In Here
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <hr data-aos="fade" className="mx-auto my-5" />
                <div className="row align-items-center">
                  <div className="col-12 col-md-6 details-img  text-center">
                    <LazyLoadImage
                      src={MountainView}
                      alt="Mountain View Veterinary Surgery"
                      className="img-fluid"
                      effect="blur"
                    />
                  </div>
                  <div className="col-12 col-md-6 details-info">
                    <div className="contact">
                      <p>
                        <strong>MOUNTAIN VIEW VETERINARY SURGERY</strong>
                      </p>
                      <div className="contact-item">
                        <div className="contact-icon">
                          <span className="fa fa-phone" />
                        </div>
                        <div className="contact-label">PHONE NUMBER</div>
                        <div className="contact-text">
                          <a href="tel:7192724004">719-272-4004</a>
                        </div>
                      </div>
                      <div className="contact-item">
                        <div className="contact-icon">
                          <span className="fa fa-globe" />
                        </div>
                        <div className="contact-label">WEBSITE</div>
                        <div className="contact-text">
                          <a
                            href="https://www.MVVetSurgery.com"
                            target="_blank"
                            rel="noopener noferrer"
                          >
                            www.MVVetSurgery.com
                          </a>
                        </div>
                      </div>
                      <div className="contact-item">
                        <div className="contact-icon">
                          <span className="fa fa-paw" />
                        </div>
                        <div className="contact-label">SPECIALTY</div>
                        <div className="contact-text">
                          Veterinary Soft Tissue Surgery
                        </div>
                      </div>
                      <div className="contact-item">
                        <div className="contact-icon">
                          <span className="fa fa-medkit" />
                        </div>
                        <div className="contact-label">VET REFERRAL PORTAL</div>
                        <div className="contact-text">
                          <a
                            href="http://www.veterinaryspecialty.com/vets"
                            target="_blank"
                            rel="noopener noferrer"
                          >
                            Log In Here
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <hr data-aos="fade" className="mx-auto my-5" />
                <div className="row align-items-center">
                  <div className="col-12 col-md-6 details-img text-center">
                    <LazyLoadImage
                      src={AADC}
                      alt="AADC"
                      className="img-fluid"
                      effect="blur"
                      style={{ maxWidth: "20em" }}
                    />
                  </div>
                  <div className="col-12 col-md-6 details-info">
                    <div className="contact">
                      <p>
                        <strong>
                          ANIMAL ALLERGY & DERMATOLOGY OF COLORADO
                        </strong>
                      </p>
                      <div className="contact-item">
                        <div className="contact-icon">
                          <span className="fa fa-phone" />
                        </div>
                        <div className="contact-label">PHONE NUMBER</div>
                        <div className="contact-text">
                          <a href="tel:7193582636">719-358-2636</a>
                        </div>
                      </div>
                      <div className="contact-item">
                        <div className="contact-icon">
                          <span className="fa fa-globe" />
                        </div>
                        <div className="contact-label">WEBSITE</div>
                        <div className="contact-text">
                          <a
                            href="https://animalallergycolorado.com/"
                            target="_blank"
                            rel="noopener noferrer"
                          >
                            www.animalallergycolorado.com
                          </a>
                        </div>
                      </div>
                      <div className="contact-item">
                        <div className="contact-icon">
                          <span className="fa fa-paw" />
                        </div>
                        <div className="contact-label">SPECIALTY</div>
                        <div className="contact-text">
                          Allergy and Dermatology
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Layout>
    )
  }
}

export default IndexPage

export const indexPageQuery = graphql`
  query indexPageQuery {
    site {
      siteMetadata {
        title
        author
        description
      }
    }
  }
`
